const currencyMap: Record<string, string> = {
  USD: '$',
  XCD: '$',
  TWD: '$',
  TVD: '$',
  AUD: '$',
  TTD: '$',
  SRD: '$',
  SGD: '$',
  SBD: '$',
  NZD: '$',
  NAD: '$',
  KYD: '$',
  KID: '$',
  JMD: '$',
  HKD: '$',
  GYD: '$',
  FJD: '$',
  CAD: '$',
  BZD: '$',
  BSD: '$',
  BND: '$',
  BMD: '$',
  BBD: '$',
  GBP: '£',
  EGP: '£',
  LBP: '£',
  SSP: '£',
  SDG: '£',
  SYP: '£',
  IMP: '£',
  JEP: '£',
  GGP: '£',
  GIP: '£',
  EUR: '€',
}

export const formatMoney = function (unformattedValue: number, precision: number): string {
  // doesn't work correctly with numbers bigger than 999,999,999,999,999
  if (
    unformattedValue === null ||
    typeof unformattedValue === 'undefined' ||
    !Number(unformattedValue)
  ) {
    unformattedValue = 0
  }

  const numberValue = Number(unformattedValue)
  const isNegative = numberValue < 0

  const strValue = Math.abs(numberValue).toFixed(precision)
  const pointIndex = strValue.indexOf('.')

  const numberParts = []
  const startIndex = pointIndex === -1 ? strValue.length : pointIndex

  for (let i = startIndex; i > 0; i -= 3) {
    numberParts.unshift(strValue.slice(Math.max(i - 3, 0), i))
  }

  let numberStr = numberParts.join(',')
  if (pointIndex !== -1) {
    numberStr += strValue.slice(pointIndex)
  }

  if (isNegative) {
    numberStr = '-' + numberStr
  }
  return numberStr
}

export const formatAsCurrency = (
  valueStr: string,
  currencyCode: string,
  addMinus?: boolean,
  showCurrencyCodeAfterAmount?: boolean
): string => {
  showCurrencyCodeAfterAmount =
    showCurrencyCodeAfterAmount === undefined ? true : showCurrencyCodeAfterAmount

  const currencySymbol = currencyMap[currencyCode] ? currencyMap[currencyCode] : ''

  let result = currencySymbol + valueStr

  if (showCurrencyCodeAfterAmount && typeof currencyCode !== 'undefined' && currencyCode !== null) {
    result += ' ' + currencyCode
  }

  if (addMinus) {
    result = '-' + result
  }

  return result
}

export function formatCurrency(
  value: number,
  currencyCode: string,
  precision?: number,
  showCurrencyCodeAfterAmount?: boolean
): string {
  precision = Number(precision)
  precision = isNaN(precision) ? 2 : precision
  precision = precision < 0 ? 0 : precision

  const sign = Math.sign(value)
  const formattedValue = formatMoney(Math.abs(value), precision)

  return formatAsCurrency(formattedValue, currencyCode, sign < 0, showCurrencyCodeAfterAmount)
}
